import { useState } from "react";
import { toast } from "react-toastify";
import { useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { StackActions } from "@react-navigation/native";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { base_url, endpoints } from "../../Api/configs";
import { searchUsers } from "../../services/eventsAPI";
import { CreateNewChat } from "../../services/chatAPI";
import { handleApiError } from "../../services/errorHandler";

export const useChatApi = () => {
  const [showLoader, setShowLoader] = useState(false);
  const navigation = useNavigation();

  const callSearchUserAPI = async (
    username,
    accessToken,
    currentUsername,
    handleCreateChat
  ) => {
    setShowLoader(true);
    const params = { query: username };

    try {
      const data = await searchUsers(params);
      setShowLoader(false);

      if (
        data.statusCode === 200 &&
        data.body &&
        data.body.results.length > 0
      ) {
        const results = data.body.results;
        if (results.length === 1) {
          handleCreateChat([results[0].userID], accessToken, currentUsername);
        } else {
          toast.error("Multiple users found");
        }
      } else {
        toast.error("User not found");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  const chatCreateAPI = async (userIds, accessToken, type = "single") => {
    setShowLoader(true);

    try {
      const response = await CreateNewChat(userIds, accessToken, type);
      setShowLoader(false);

      if (response.statusCode === 200) {
        navigateToScreen(navigation, AppScreens.Chat);
        toast.success("Chat created successfully");
        return response.body;
      } else if (response.statusCode === 400) {
        toast.error("Chat already exist");
      } else {
        handleApiError(
          response.status,
          response.body.message || "An error occurred"
        );
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  return {
    showLoader,
    callSearchUserAPI,
    chatCreateAPI,
  };
};
